'use client';

import { useTranslations } from 'next-intl';
import React, { useRef } from 'react';

import HomePageCard from '@/app/[locale]/(default-layout)/_components/HomePageCard';
import SectionTitle from '@/app/[locale]/(default-layout)/_components/SectionTitle';

import { CinemaCardDto } from '@cineamo/api/models/cinema-card/CinemaCardDto.types';

import { styleFaded } from '@cineamo/ui/src/helpers/style-helper';

import useScrollState from '@cineamo/ui/src/hooks/useScrollState';

import BackAndForthButtonOverlay from '@cineamo/ui/src/button/BackAndForthButtonOverlay';

import CenterLayout from '@cineamo/composables/src/CenterLayout';

type HomeCinemaCardsSectionProps = {
    cinemaCards: CinemaCardDto[];
};

const CinemaCardsSectionContent: React.FC<HomeCinemaCardsSectionProps> = ({ cinemaCards }) => {
    const t = useTranslations();
    const cinemaCardsScrollContainerRef = useRef(null);

    const { styleFadedState } = useScrollState({
        scrollContainerRef: cinemaCardsScrollContainerRef,
        initialState: {
            startReached: true,
            endReached: false
        },
        refreshTrigger: cinemaCards
    });

    const fadeStyle = styleFaded(styleFadedState, 5);

    return (
        <section
            role="group"
            aria-label={t('home.did-you-know')}>
            <CenterLayout className="space-y-12 lg:space-y-16">
                <SectionTitle title={t('home.did-you-know')} />
                <div className="relative flex flex-row">
                    <div
                        className="relative w-full flex flex-row space-x-16 overflow-x-auto no-scrollbar"
                        style={fadeStyle}
                        ref={cinemaCardsScrollContainerRef}>
                        {cinemaCards.map((cinemaCard, index) => (
                            <HomePageCard
                                key={`HomePageCard#${index}`}
                                url={cinemaCard.url}
                                text={cinemaCard.text}
                                title={cinemaCard.name}
                                buttonText={cinemaCard.buttonText}
                                cardBackground={cinemaCard.imageUrl}
                                cardBackgroundAlt={cinemaCard.imageDescription}
                            />
                        ))}
                    </div>
                    {cinemaCards.length > 0 && (
                        <BackAndForthButtonOverlay
                            scrollContainerRef={cinemaCardsScrollContainerRef}
                            renderOutside
                        />
                    )}
                </div>
            </CenterLayout>
        </section>
    );
};

export default CinemaCardsSectionContent;
